import React from 'react';
import PageHeader from './PageHeader';
import DashboardFamilyHeader from '../dashboard/DashboardFamilyHeader';

/**
 * Compose dashboard-family context toolbar zones (Shell Target Spec v1.0 §3.4).
 */
export function mergeFamilyHeaderChrome(familyHeader, { toolbar, filters, center } = {}) {
  if (!familyHeader) return undefined;

  const mergedCenter = center ?? filters ?? familyHeader.center;
  const mergedToolbar = toolbar;
  const hasCenter = Boolean(mergedCenter);
  const hasToolbar = Boolean(mergedToolbar);

  if (!hasCenter && !hasToolbar) return familyHeader;

  return {
    ...familyHeader,
    ...(hasCenter ? { center: mergedCenter } : {}),
    ...(hasToolbar
      ? {
          actions: (
            <>
              {familyHeader.actions}
              {mergedToolbar}
            </>
          ),
        }
      : {}),
  };
}

/**
 * Resolve page chrome for floorplan templates.
 * Priority: explicit header → familyHeader (context toolbar) → title PageHeader (only if subtitle/actions).
 */
export function resolveTemplateHeader({
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
}) {
  if (header) return header;
  if (familyHeader) {
    return <DashboardFamilyHeader {...familyHeader} />;
  }
  if (title && (subtitle || headerActions)) {
    return <PageHeader title={title} subtitle={subtitle} actions={headerActions} />;
  }
  return null;
}

export default resolveTemplateHeader;
